
import React from 'react';
import '../App.css';


export default function Venta() {

  const Logo = "images/icon/am02.png";

  return (
    <>

      <div className='venta'>
          <img src={ Logo } alt="AgroMax" />
      </div>
      
    </>
  );
}